import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import styles from './loader.css';
import PropTypes from 'prop-types';

import topBlock from './top-block.svg';
import middleBlock from './middle-block.svg';
import bottomBlock from './bottom-block.svg';
const messages = [
    {
        message: (
            <FormattedMessage
                defaultMessage="Creating blocks …"
                description="One of the loading messages"
                id="gui.loader.message1"
            />
        ),
        weight: 50
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Loading sprites …"
                description="One of the loading messages"
                id="gui.loader.message2"
            />
        ),
        weight: 50
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Loading sounds …"
                description="One of the loading messages"
                id="gui.loader.message3"
            />
        ),
        weight: 50
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Loading extensions …"
                description="One of the loading messages"
                id="gui.loader.message4"
            />
        ),
        weight: 50
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Creating blocks …"
                description="One of the loading messages"
                id="gui.loader.message1"
            />
        ),
        weight: 20
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Herding cats …"
                description="One of the loading messages"
                id="gui.loader.message5"
            />
        ),
        weight: 1
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Transmitting nanos …"
                description="One of the loading messages"
                id="gui.loader.message6"
            />
        ),
        weight: 1
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Inflating gobos …"
                description="One of the loading messages"
                id="gui.loader.message7"
            />
        ),
        weight: 1
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Preparing emojis …"
                description="One of the loading messages"
                id="gui.loader.message8"
            />
        ),
        weight: 1
    }
];
const mainMessages = {
    'gui.loader.headline': (
        <FormattedMessage
            defaultMessage="Loading Project"
            description="Main loading message"
            id="gui.loader.headline"
        />
    ),
    'gui.loader.creating': (
        <FormattedMessage
            defaultMessage="Creating Project"
            description="Main creating message"
            id="gui.loader.creating"
        />
    )
};
class Countdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { timeLeft: '...' };
    }
    
    componentDidMount() {
        this.tick();
        this.intervalId = setInterval(this.tick, 1000);
    }
    
    componentWillUnmount() {
        clearInterval(this.intervalId);
    }
    
    tick = () => {
        const targetDate = new Date(this.props.target);
        const diff = targetDate.getTime() - Date.now();
        
        if (diff <= 0) {
            this.setState({ timeLeft: 'Starting now...' });
            clearInterval(this.intervalId);
            window.dispatchEvent(new CustomEvent('sessionCountdownFinished'));
            return;
        }

        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const m = Math.floor((diff / 1000 / 60) % 60);
        const s = Math.floor((diff / 1000) % 60);
        
        let parts = [];
        if (d > 0) parts.push(`${d}d`);
        if (h > 0) parts.push(`${h}h`);
        if (m > 0) parts.push(`${m}m`);
        parts.push(`${s}s`);
        
        this.setState({ timeLeft: parts.join(' ') });
    }
    
    render() {
        return <div className={styles.countdown}>{this.state.timeLeft}</div>;
    }
}
Countdown.propTypes = {
    target: PropTypes.string.isRequired
};

class LoaderComponent extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            messageNumber: this.chooseRandomMessage()
        };
        this.intervalId = null;
    }
    startRandomMessageInterval() {
        if (this.intervalId) return; 
        this.intervalId = setInterval(() => {
            this.setState({messageNumber: this.chooseRandomMessage()});
        }, 5000);
    }

    stopRandomMessageInterval() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
    componentDidMount () {
        // Start an interval to choose a new message every 5 seconds
        if (!this.props.sessionStatus || this.props.sessionStatus.status === 'loading') {
            // --- USE HELPER ---
            this.startRandomMessageInterval(); 
        }
    }
    componentWillUnmount () {
        this.stopRandomMessageInterval();
    }
    componentDidUpdate(prevProps) {
        const newStatus = this.props.sessionStatus?.status;
        const oldStatus = prevProps.sessionStatus?.status;
        
        if (newStatus !== oldStatus) {
            if (newStatus !== 'loading' && this.intervalId) {
                this.stopRandomMessageInterval();
            } else if (newStatus === 'loading' && !this.intervalId) {
                this.startRandomMessageInterval();
            }
        }
    }
    chooseRandomMessage () {
        let messageNumber;
        const sum = messages.reduce((acc, m) => acc + m.weight, 0);
        let rand = sum * Math.random();
        for (let i = 0; i < messages.length; i++) {
            rand -= messages[i].weight;
            if (rand <= 0) {
                messageNumber = i;
                break;
            }
        }
        return messageNumber;
    }
    render () {
        const status = this.props.sessionStatus?.status || 'loading';
        const message = this.props.sessionStatus?.message;
        const countdownTo = this.props.sessionStatus?.countdownTo;

        let mainMessage;
        if (status === 'countdown') {
            mainMessage = message || "Session Starting Soon"; 
        } else if (status === 'error') {
            mainMessage = "Connection Error";
        } else {
            mainMessage = mainMessages[this.props.messageId] || mainMessages['gui.loader.headline']; //
        }
        
        let subMessageContent;

        if (status === 'countdown' && countdownTo) {
            subMessageContent = <Countdown target={countdownTo} />; 
        } else if (status === 'error') {
            subMessageContent = <div className={styles.message}>{message || "An unknown error occurred."}</div>;
        } else if (status === 'loading' && message && message !== 'Initializing...') {
            subMessageContent = <div className={styles.message}>{message}</div>;
        } else {
            subMessageContent = (
                <div className={styles.messageContainerOuter}>
                    <div
                        className={styles.messageContainerInner}
                        style={{transform: `translate(0, -${this.state.messageNumber * 25}px)`}}
                    >
                        {messages.map((m, i) => ( 
                            <div className={styles.message} key={i}>{m.message}</div>
                        ))}
                    </div>
                </div>
            );
        }
        return (
            <div
                className={classNames(styles.background, {
                    [styles.fullscreen]: this.props.isFullScreen
                })}
            >
                <div className={styles.container}>
                    <div className={styles.blockAnimation}>
                        <img
                            className={styles.topBlock}
                            src={topBlock}
                        />
                        <img
                            className={styles.middleBlock}
                            src={middleBlock}
                        />
                        <img
                            className={styles.bottomBlock}
                            src={bottomBlock}
                        />
                    </div>
                    <div className={styles.title}>
                        {mainMessage}
                    </div>
                    {subMessageContent}
                </div>
            </div>
        );
    }
}

LoaderComponent.propTypes = {
    isFullScreen: PropTypes.bool,
    messageId: PropTypes.string, 
    sessionStatus: PropTypes.shape({ 
        status: PropTypes.oneOf(['loading', 'countdown', 'error', 'ready']),
        message: PropTypes.string,
        countdownTo: PropTypes.string 
    })
};
LoaderComponent.defaultProps = {
    isFullScreen: false,
    messageId: 'gui.loader.headline',
    sessionStatus: { 
      status: 'loading',
      message: 'Initializing...',
      countdownTo: null
    }
};

export default LoaderComponent;
